// material
import { Container, LinearProgress, Typography } from '@mui/material';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import { useTranslation } from 'react-i18next';
import { UpdateForm } from 'components/authentication/update';
import { useSelector, RootState } from '../../redux/store';

// ----------------------------------------------------------------------

export default function UnderConstruction() {
  const { themeStretch } = useSettings();
  const { t } = useTranslation();
  const { loaded, user } = useSelector((state: RootState) => state.user);

  return (
    <Page title={t('update_profile')}>
      <Container maxWidth={themeStretch ? false : 'sm'}>
        <Typography variant="h3" component="h1" paragraph>
          {t('update_profile')}
        </Typography>
        <Typography style={{ marginBottom: '50px' }} gutterBottom>
          {t('update_profile_text')}
        </Typography>
        {loaded && user ? <UpdateForm userData={user} /> : <LinearProgress />}
      </Container>
    </Page>
  );
}
